import { useRecoilValue, useRecoilState } from "recoil";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import _ from "lodash";
import {
  Title,
  Text,
  Space,
  Paper,
  Table,
  Loader,
  Center,
  Group,
  ActionIcon,
  Menu,
} from "@mantine/core";
import { Colors } from "../../global";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { BiDotsVertical } from "react-icons/bi";
import classes from "../Stores/Stores.module.css";

function Reports() {
  const stores = useRecoilValue(allSitesAtom);
  const navigate = useNavigate();

  const rows = stores.stores?.Items?.map((store) => (
    <Table.Tr
      key={store.project_id}
      onClick={() => navigate(`/stores/${store.project_id}/edit`)}
    >
      <Table.Td w={5}>
        <Text size="sm" ta="center">
          {store.settings.projectIdentifier}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm" ta="center">
          {store.settings.projectName}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm" ta="center">
          {store.settings.projectOwner}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm" ta="center">
          Email
        </Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm" ta="center">
          {store.tools.length}
        </Text>
      </Table.Td>
      <Table.Td w={10} visibleFrom="sm">
        <Center>
          <Menu
            shadow="md"
            trigger="click-hover"
            classNames={{
              item: classes.item,
            }}
          >
            <Menu.Target>
              <ActionIcon
                variant="subtle"
                color={Colors.main}
                size="lg"
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                <BiDotsVertical />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown w={100}>
              <Menu.Item
                onClick={(event) => {
                  event.stopPropagation();
                  navigate(`/stores/${store.project_id}/edit`);
                }}
              >
                Edit
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Center>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <Group justify="space-between">
        <div>
          <Title order={2}>Stores</Title>
          <Text c="dimmed" size="sm">
            View Stores and change settings.
          </Text>
        </div>

        <ActionIcon
          onClick={() => navigate("/stores/add")}
          mr={20}
          size="lg"
          color={Colors.main}
        >
          <FiPlus size="1.6rem" />
        </ActionIcon>
      </Group>
      <Space h="md" />

      {rows ? (
        <Paper withBorder radius="sm">
          <Table
            withColumnBorders
            stickyHeader
            highlightOnHover
            verticalSpacing="md"
          >
            <Table.Thead style={{ backgroundColor: "#DDDDDF" }}>
              <Table.Tr>
                <Table.Th>
                  <Center>Store Number</Center>
                </Table.Th>
                <Table.Th>
                  <Center>Store Name</Center>
                </Table.Th>
                <Table.Th>
                  <Center>Store Manager</Center>
                </Table.Th>
                <Table.Th>
                  <Center>Store Email</Center>
                </Table.Th>
                <Table.Th>
                  <Center>Sensor Count</Center>
                </Table.Th>
                <Table.Th visibleFrom="sm">
                  <Center>Action</Center>
                </Table.Th>
              </Table.Tr>
            </Table.Thead>

            <Table.Tbody style={{ backgroundColor: "#FFFFFF" }}>
              {rows}
            </Table.Tbody>
          </Table>
        </Paper>
      ) : (
        <>
          <Space h="md" />
          <Center>
            <Loader color={Colors.main} />
          </Center>
          <Space h="md" />
        </>
      )}
    </>
  );
}

export default Reports;
